import { Injectable } from '@angular/core';
 
import {TimeManagerProvider} from '../../providers/time-manager/time-manager';
import { Events } from '../../providers/events/events';
import { LoggerService } from '../../app/services/logger.service';
/*
  Generated class for the AppStateManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AppStateManagerProvider {
  public static foreground : boolean = true;
  constructor( 
    public timeManager: TimeManagerProvider, 
    public events: Events,
    public logger: LoggerService
  ) {
        this.logger.debug('Hello AppStateManagerProvider Provider');
        if (AppStateManagerProvider.isActive()){
            this.logger.debug("lets start timer");
                 this.timeManager.startTimer();
        }
        var self = this;
        document.addEventListener("resume", function(){self.onResume(self)}, false);
        document.addEventListener("pause", function(){self.onPause(self)}, false);
  }
  onResume(appStMrg: AppStateManagerProvider){
        AppStateManagerProvider.foreground = true;
        this.logger.debug("timer should resume");
        appStMrg.timeManager.startTimer();
        this.events.publish("resumeApp");
        
    }

    onPause(appStMrg: AppStateManagerProvider) {
        AppStateManagerProvider.foreground = false;
        this.logger.debug("timer should pause");
        appStMrg.timeManager.stopTimer();
    }
    public static isActive(){
        return AppStateManagerProvider.foreground;
    }

}
